import React from 'react';
type GradientCtaProps = {
  children: React.ReactNode;
  /** Cél. Üres string esetén (pl. még nincs checkout link) gombként jelenik meg, navigáció nélkül. */
  href?: string;
  tone?: 'lavender' | 'light';
  checkout?: boolean;
};
const tones = {
  lavender: 'bg-gradient-to-r from-[#D8CCF6] to-[#F3B6D0] shadow-[0_14px_30px_-12px_rgba(214,140,190,0.7)] focus-visible:ring-lavender-deep',
  light: 'bg-gradient-to-r from-white to-[#F6C3D8] shadow-[0_14px_30px_-12px_rgba(60,30,90,0.5)] focus-visible:ring-white focus-visible:ring-offset-[#9579CC]'
};
export function GradientCta({
  children,
  href = '#ajanlat',
  tone = 'lavender',
  checkout = false
}: GradientCtaProps) {
  const className = `flex w-full items-center justify-center gap-2 rounded-full px-6 py-5 text-center font-display text-lg font-extrabold uppercase leading-snug tracking-tight text-ink transition-transform duration-150 ease-out hover:scale-[1.01] active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 sm:py-6 sm:text-2xl ${tones[tone]}`;
  if (!href) {
    return <button type="button" data-checkout={checkout ? 'pending' : undefined} className={className} data-id="element-103" data-mp="3jl0g4754zy1">
        {children}
      </button>;
  }
  return <a href={href} data-checkout={checkout ? 'ready' : undefined} className={className} data-id="element-104" data-mp="i7y0bc9cn2xt">
      {children}
    </a>;
}